export const corrChartColors = [
  {
    id: '1',
    color: '#8FACFF',
  },
  {
    id: '2',
    color: '#C37CFF',
  },
  {
    id: '3',
    color: '#FF87E6',
  },
  {
    id: '4',
    color: '#FF6585',
  },
  {
    id: '5',
    color: '#FFB34D',
  },
  {
    id: '6',
    color: '#A5FF62',
  },
  {
    id: '7',
    color: '#62FFE3',
  },
  {
    id: '8',
    color: '#DDDDDD',
  },
  {
    id: '9',
    color: '#FCFF62',
  },
];